import { Observable } from 'rxjs';
import { TokenTypeModel, NewTokenRequest } from '@src/core/domain/token/tokenType.model';

export abstract class TokenRepository {
  abstract getToken(): Observable<TokenTypeModel>;
  abstract getNewToken(params: NewTokenRequest): Observable<TokenTypeModel>;
  abstract getNewTokenExtract(): Observable<TokenTypeModel>;
}
